import { render, staticRenderFns } from "./ativacao.vue?vue&type=template&id=13defa66"
import script from "./ativacao.vue?vue&type=script&lang=js"
export * from "./ativacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports